import customerReducer from './';

export default customerReducer;
